export default __webpack_public_path__ + "static/media/diseno.778d383e.png";